import { render, staticRenderFns } from "./DateValidation.vue?vue&type=template&id=24279f8d&scoped=true&"
import script from "./DateValidation.vue?vue&type=script&lang=js&"
export * from "./DateValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24279f8d",
  null
  
)

export default component.exports